import {
  Callbacks,
  getMessageBoxService,
} from "src/Contexto/MessageBox.Context";
import {
  MessageBoxButton,
  MessageBoxIcon,
} from "src/interfaces/MessageBox/IMessageBoxButton";

export const showMessageBox = async (
  msg: string,
  title: string,
  buttons: MessageBoxButton,
  icon: MessageBoxIcon,
  callbacksParam: Callbacks
) => {
  const service = getMessageBoxService();
  if (!service) {
    console.warn("⚠️ MessageBoxProvider ainda não foi inicializado.");
    return;
  }

  service.ShowMessage(msg, title, buttons, icon, callbacksParam);
};
